<template>
  <ul class="nav">
    <li class="nav-item" >
      <div class="nav-link" exact><i class="ico icon-arrow-left"></i>  Menu Principal</div>
    </li>
    <li class="nav-title">
      {{$lang.Menu.Items.Configuration.General}}
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_AREA)">
      <router-link :to="{ name: 'Area' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Area}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_BANK)">
      <router-link :to="{ name: 'Banco' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Banks}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_HOLIDAY)">
      <router-link :to="{ name: 'Feriados' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Holidays}}
      </router-link>
    </li>
    <li class="nav-title">
      {{$lang.Menu.Items.Configuration.Institutional}}
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_BRANCH)">
      <router-link :to="{ name: 'Filiais' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Branch}}
      </router-link>
    </li>
    <li class="nav-title">
      {{$lang.Menu.Items.Configuration.Clients}}
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_INSURERS)">
      <router-link :to="{ name: 'Seguradora' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Insurer}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_BUSINESSTYPE)">
      <router-link :to="{ name: 'TipoNegocio' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.BusinessType}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_INSURED)">
      <router-link :to="{ name: 'Segurado' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Insured}}
      </router-link>
    </li>
    <li class="nav-title">
      {{$lang.Menu.Items.Configuration.Roles}}
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_EXPERT)">
      <router-link :to="{ name: 'Perito' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Expert}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_SERVICEREGIONS)">
      <router-link :to="{ name: 'RegioesAtendimento' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.RegionsService}}
      </router-link>
    </li>
    <li class="nav-title">
      {{$lang.Menu.Items.Configuration.Regulation}}
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_STAGES)">
      <router-link :to="{ name: 'Estagio' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Stages}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.MENU_SINISTER)">
      <router-link :to="{ name: 'TipoVistoria' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.InspectionType}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_DOCUMENTTYPE)">
      <router-link :to="{ name: 'TipoDocumento' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.TypeDocuments}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_IMAGESTTYPE)">
      <router-link :to="{ name: 'TipoImage' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.TypeImages}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_BUDGETSYSTEM)">
      <router-link :to="{ name: 'SistemaOrcamentacao' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.BudgetSystem}}
      </router-link>
    </li>
    <li class="nav-title">
      {{$lang.Menu.Items.Configuration.Scheduling}}
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_SCHEDULINGTYPE)">
      <router-link :to="{ name: 'FormasVistoria' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.SchedulingType}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_SCHEDULINGCONTACT)">
      <router-link :to="{ name: 'ContatoVistoria' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.SchedulingContact}}
      </router-link>
    </li>
    <li class="nav-title">
      {{$lang.Menu.Items.Configuration.Expertise}}
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_WORKSHOP)">
      <router-link :to="{ name: 'Oficina-Cfg' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.MechanicalWorkshop}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_AUTOTYPE)">
      <router-link :to="{ name: 'TipoVeiculo' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.TypeVehicle}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_AUTOBRAND)">
      <router-link :to="{ name: 'Fabricante' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Brand}}
      </router-link>
    </li>
    <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_AUTOMODEL)">
      <router-link :to="{ name: 'Modelo' }" class="nav-link" exact>
        <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Model}}
      </router-link>
    </li>
  </ul>
</template>
<script>
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'sidebarconfig',
  mixins: [ PermissionMixin ],
  data () {
    return {
      roles: Roles
    }
  },
  methods: {
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i].role === role) {
            result = true
          }
        }
      }
      return result
    }
  }
}
</script>
<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/containers/layout/SidebarConfig.vue